import { useEffect, useState } from 'react'
import { apiClient } from 'pobble-components/dist/api'
import { errorHandler } from 'pobble-components/dist/error-handler'

export const PARENT_WRITING_INCLUDE =
  'parent_writing.last_parent_writing_work_version,parent_writing.last_parent_writing_work_version.work,parent_writing.last_parent_writing_work_version.work.medium,parent_writing.last_parent_writing_work_version.work.medium.details,parent_writing.last_parent_writing_work_version.work.medium.image,parent_writing.last_parent_writing_work_version.typed_body,parent_writing.last_parent_writing_work_version.typed_body_cache'

export const useParentWriting = parentWritingId => {
  const [parentWriting, setParentWriting] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(
    () => {
      if (!parentWritingId) {
        setParentWriting(null)
        setIsLoading(false)
        return
      }

      let mounted = true
      setIsLoading(true)

      apiClient
        .get(`/v3/parent_writings/${parentWritingId}`, {
          params: {
            include: PARENT_WRITING_INCLUDE
          }
        })
        .then(res => {
          if (!mounted) return
          setParentWriting(res.data.parent_writing || null)
        })
        .catch(e => {
          if (!mounted) return
          errorHandler(e)
          setParentWriting(null)
        })
        .finally(() => {
          if (!mounted) return
          setIsLoading(false)
        })

      return () => {
        mounted = false
      }
    },
    [parentWritingId]
  )

  return {
    parentWriting,
    writingType: (parentWriting && parentWriting.writing_type) || null,
    workVersion:
      (parentWriting && parentWriting.last_parent_writing_work_version) || null,
    isLoading
  }
}
